/* Shared loading spinner for all async buttons — Google-style rotating arc */
export function ButtonSpinner({ size = 18, color = 'currentColor' }: { size?: number; color?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      aria-hidden="true"
      style={{ flexShrink: 0, display: 'block' }}
    >
      {/* Faint track ring */}
      <circle cx="9" cy="9" r="7" stroke={color} strokeWidth="2" strokeOpacity="0.22" />
      {/* Spinning arc — ~270° */}
      <path d="M9 2 a7 7 0 0 1 5.95 3.5" stroke={color} strokeWidth="2.2" strokeLinecap="round">
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 9 9"
          to="360 9 9"
          dur="0.72s"
          repeatCount="indefinite"
        />
      </path>
    </svg>
  );
}
